export async function registerServiceWorker(): Promise<void> {
  if (
    !import.meta.env.PROD ||
    !("serviceWorker" in navigator) ||
    !window.isSecureContext
  ) {
    return;
  }

  try {
    await navigator.serviceWorker.register("/sw.js", { scope: "/" });
  } catch (error) {
    console.error("Static shell service worker registration failed.", {
      name: error instanceof Error ? error.name : "UnknownError",
    });
  }
}
